import styled from 'styled-components';
import { getPaletteColor } from 'pcln-design-system';
var PopoverArrow = styled.div.attrs(function (_ref) {
  var borderColor = _ref.borderColor,
    color = _ref.color,
    placement = _ref.placement;
  return {
    bgColor: getPaletteColor(color, 'base'),
    brColor: getPaletteColor(borderColor, 'base'),
    'data-placement': placement,
    'data-testid': 'popover-arrow'
  };
}).withConfig({
  displayName: "Arrow__PopoverArrow",
  componentId: "sc-16wrxk0-0"
})(["&[data-placement*='left']{border-color:transparent ", " ", " transparent;}&[data-placement*='right']{border-color:", " transparent transparent ", ";}&[data-placement*='top']{border-color:transparent transparent ", " ", ";}&[data-placement*='bottom']{border-color:", " ", " transparent transparent;}position:absolute;background-color:", ";border-style:solid;border-width:1px;width:8px;height:8px;transform:rotate(-45deg);"], function (props) {
  return props.brColor;
}, function (props) {
  return props.brColor;
}, function (props) {
  return props.brColor;
}, function (props) {
  return props.brColor;
}, function (props) {
  return props.brColor;
}, function (props) {
  return props.brColor;
}, function (props) {
  return props.brColor;
}, function (props) {
  return props.brColor;
}, function (props) {
  return props.bgColor;
});
export default PopoverArrow;